import { inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { CompanyService } from 'src/app/company/company.service';
import { IOperatorClass } from './OperatorClass';
import { OperatorInput, OperatorOutput } from './models/models';

export class CommentsOperator implements IOperatorClass {
  private readonly companyService = inject(CompanyService);
  private readonly commentsWorksheetIndex = 8;

  async runOperator(operatorInput: OperatorInput): Promise<OperatorOutput> {
    const worksheet = operatorInput.workbook?.worksheets(this.commentsWorksheetIndex);
    if (!worksheet) {
      return {
        status: 'error',
        message: ['Comments sheet not found.'],
        operatorInput,
      };
    }

    const raw = worksheet.rows(1).cells(0).value != null
      ? String(worksheet.rows(1).cells(0).value).trim()
      : '';
    const comment = raw ? raw.charAt(0).toUpperCase() + raw.slice(1) : '';

    if (!comment) {
      return { status: 'skipped', operatorInput };
    }

    let resp: any;
    try {
      const add$ = this.companyService.addComment(
        operatorInput.prfyear,
        operatorInput.prfnumber ?? '',
        comment,
      );
      if (!add$) {
        return {
          status: 'error',
          message: ['Failed to add comment.'],
          operatorInput,
        };
      }
      resp = await firstValueFrom(add$);
    } catch {
      return {
        status: 'error',
        message: ['Failed to add comment.'],
        operatorInput,
      };
    }

    if (resp?.message !== 'Success') {
      return {
        status: 'error',
        message: [resp?.status_msg ?? 'Failed to add comment.'],
        operatorInput,
      };
    }

    return { status: 'success', operatorInput };
  }
}
